/*************************************************/
/* MIXITUP                                       */
/*************************************************/
import mixitup from "mixitup";

export function mix() {

    const init = () => {
        // Check if the container exists
        const container = document.querySelector('#employees-container');
        if (!container) return; // Exit if container doesn't exist

        // Initialize MixItUp only if the container exists
        const mixer = mixitup(container);

        // Check if the dropdown exists
        const dropdown = document.querySelector('.employees-overview__filter-dropdown');
        if (!dropdown) return; // Exit if dropdown doesn't exist

        // Listen for dropdown changes
        dropdown.addEventListener('change', function () {
            const selectedValue = this.value;

            if (selectedValue === '') {
                mixer.filter('all'); // Show all employees
            } else {
                mixer.filter('.' + selectedValue); // Filter by selected country class
            }
        });
    };

    init();
}
